import angular from 'angular';
import HoursSelectorComponent from './hours-selector.component';

const HoursSelectorModule = angular
    .module('control-room.commons.form.components.hours-selector', ['ui.bootstrap.dropdown'])
    .component('crHoursSelector', HoursSelectorComponent);

export default HoursSelectorModule;
